
import { useAppAxios } from "@/composables/useAppAxios";
import { computed, inject, ref } from "vue";
export default {
  setup() {
    const { exec: _fetchStats, data: dataResult } = useAppAxios();
    const stats = ref({} as any);
    const fetchStats = async () => {
      await _fetchStats({
        method: "GET",
        url: "/vote/stats",
      });
      stats.value = dataResult.value;
    };
    fetchStats();

    const socket = inject<any>("socket");
    socket.on("voteStats", (newStats) => {
      stats.value = newStats;
    });
    const statistics = computed(() => stats.value.stats || []);
    const total = computed(() => stats.value.total);
    return { total };
  },
};
